module.exports = __webpack_public_path__ + "media/images/calculos_laborales_bg-4b1bbbdd.png";